import { z } from "zod";
import { StageType, TieBreakerCriterion } from "@/core/value-objects/StageConfig";

// Enums para Stage Config
export const StageTypeSchema = z.nativeEnum(StageType);

export const TieBreakerCriterionSchema = z.nativeEnum(TieBreakerCriterion);

// Stage Config Schemas
export const TieBreakerRuleSchema = z.object({
  criterion: TieBreakerCriterionSchema,
  order: z.number(),
});

export const ScoringRulesSchema = z.object({
  pointsPerWin: z.number(),
  pointsPerDraw: z.number(),
  pointsPerLoss: z.number(),
  tieBreakers: z.array(TieBreakerRuleSchema),
});

export const StageStructureSchema = z.object({
  groupsCount: z.number().optional(),
  teamsPerGroup: z.number().optional(),
  knockoutRound: z.string().optional(),
  knockoutTeamsCount: z.number().optional(),
  knockoutMatchesCount: z.number().optional(),
  isDoubleLeg: z.boolean(),
  hasExtraTime: z.boolean(),
  hasPenalties: z.boolean(),
});

export const SportsAdvantageSchema = z.object({
  enabled: z.boolean(),
  sourceStageOrder: z.number(),
  sourcePosition: z.number(),
});

export const StageProgressionSchema = z.object({
  promotedCount: z.number(),
  bestThirdsCount: z.number().optional(),
});

export const SlotMappingSchema = z.object({
  slot: z.string(),
  source: z.enum(["GROUP_RANK", "BEST_THIRD"]),
  group: z.string().optional(),
  rank: z.number().optional(),
  pool: z.array(z.string()).optional(),
});

export const StageConfigSchema = z.object({
  type: StageTypeSchema,
  order: z.number(),
  name: z.string(),
  rules: ScoringRulesSchema,
  structure: StageStructureSchema,
  advantage: SportsAdvantageSchema.optional(),
  progression: StageProgressionSchema,
  isConsolation: z.boolean().optional(),
  mappings: z.array(SlotMappingSchema).optional(),
});

export const EventMatchSchema = z.object({
  homeTeamId: z.string(),
  awayTeamId: z.string(),
  date: z.string(),
  time: z.string(),
  homeScore: z.number().optional().default(0),
  awayScore: z.number().optional().default(0),
  status: z.string().optional().default("scheduled"),
  order: z.number().optional(),
});

export const ManualGroupSetupSchema = z.object({
  type: z.literal("GROUPS").default("GROUPS"),
  stageOrder: z.number().optional(),
  teamsPerGroup: z.number().min(1),
  groups: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
    })
  ),
  assignments: z.record(z.string(), z.string().nullable()),
});

export const ManualKnockoutSetupSchema = z.object({
  stageOrder: z.number(),
  matches: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      participantIds: z.array(z.string()).max(2),
    })
  ),
});

// export const TournamentFormatConfigSchema = z.object({
//   stages: z.array(StageConfigSchema),
// });
export const TournamentFormatConfigSchema = z.object({
  stages: z.array(StageConfigSchema).optional().default([]),
  matches: z.array(EventMatchSchema).optional(),
  subCategoryId: z.string().optional(),
  manualGroupSetup: ManualGroupSetupSchema.optional(),
  manualGroupSetups: z.record(z.string(), ManualGroupSetupSchema).optional(),
  manualKnockoutSetups: z.record(z.string(), ManualKnockoutSetupSchema).optional(),
});
